import { useRef, useState } from "react";
import { FilterPanel, Input, Button, Title } from "../../components";
import WinzRatesTable from "./components/WinzRatesTable";
import useTableData from "../../hooks/useTableData";
import WinzRatesService from "./winzrates.service";
import { events } from "../../utils/constants";
import { FaSearch } from "react-icons/fa";
import CreateWinzRateModal from "./components/createWinzRateModal";
import "./index.css";

function WinzRatesPage() {
  const {
    data,
    sortColumn,
    sortType,
    loading,
    activeFilters,
    filtersRef,
    currentPage,
    pageSize,
    totalItems,
    searchTerm,
    handleSortColumn,
    applyFilters,
    getColumnValues,
    setFilterValues,
    getFilterValues,
    handlePageChange,
    handlePageSizeChange,
    handleSearchChange,
  } = useTableData({
    service: WinzRatesService,
    initialFilters: {
      rateCode: [],
      maxRate: [],
    },
    entityName: "winzrates",
    serviceUpdateEvent: events.WINZ_RATES_UPDATED,
    filterableColumns: ["rateCode", "maxRate"],
    searchableColumns: ["rateCode", "maxRate"],
    columnTypes: {
      rateCode: "string",
      maxRate: "number"
    },
  });
  
  // UI state for the filter panel
  const activeFilterColumnKey = useRef(null);
  const [isCheckPickerOpen, setIsCheckPickerOpen] = useState(false);
  const [createModalOpen, setCreateModalOpen] = useState(false);

  const openCheckPickerForColumn = (columnKey) => {
    activeFilterColumnKey.current = columnKey;
    setFilterValues(filtersRef.current[columnKey] || []);
    setIsCheckPickerOpen(true);
  };

  const applyCurrentFilters = () => {
    const selectedValuesFromPanel = getFilterValues();
    filtersRef.current = {
      ...filtersRef.current,
      [activeFilterColumnKey.current]: selectedValuesFromPanel,
    };
    applyFilters();
    setIsCheckPickerOpen(false);
  };

  function onFilterChange(selectedValues) {
    setFilterValues(selectedValues);
  }

  const cancelFiltering = () => {
    setIsCheckPickerOpen(false);
  };

  const getValuesForActiveColumn = () => {
    if (!activeFilterColumnKey.current) return [];
    return getColumnValues(activeFilterColumnKey.current);
  };

  // Handler to reload data after creating a winz rate
  const handleWinzRateCreated = () => {
    WinzRatesService.loadData(true);
  };

  return (
    <div className="winz-rates-page">
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16, width: "100%" }}>
        <Title text="WINZ SUBSIDY RATES" />
        <Input
          label="Search"
          value={searchTerm}
          onChange={(e) => handleSearchChange(e.target?.value || "")}
          placeholder="Search winz rates..."
          style={{ marginRight: 8, width: 400 }}
          icon={<FaSearch />}
        />
        <Button
          type="button"
          className="create-winz-rate-btn"
          onClick={() => setCreateModalOpen(true)}
          text="Create Winz Rate"
        />
      </div>
      {isCheckPickerOpen && activeFilterColumnKey.current && (
        <FilterPanel
          activeColumn={activeFilterColumnKey.current}
          filterOptions={getValuesForActiveColumn()}
          selectedValues={filtersRef.current[activeFilterColumnKey.current] || []}
          onApply={applyCurrentFilters}
          onCancel={cancelFiltering}
          onFilterChange={onFilterChange}
        />
      )}
      <WinzRatesTable
        data={data}
        sortColumn={sortColumn}
        sortType={sortType}
        onSortColumn={handleSortColumn}
        loading={loading}
        activeFilters={activeFilters}
        onFilterClick={openCheckPickerForColumn}
        currentPage={currentPage}
        pageSize={pageSize}
        totalItems={totalItems}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
      />
      <CreateWinzRateModal
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSave={handleWinzRateCreated}
      />
    </div>
  );
}

export default WinzRatesPage;
